<template>
    <tr>
        <td class="cell-condition"><strong class="d-block d-md-none text-dark">{{ $t('conditionRow.title') }}</strong>
            <span v-html="condition.toString()"></span>
        </td>
        <td class="cell-switch">
            <input type="checkbox" :id="'condition' + condition.id" checked data-switch="bool" v-model="condition.is_active"/>
            <label :for="'condition' + condition.id" :data-on-label="$t('common.yes')" :data-off-label="$t('common.no')" class="mt-1"></label>
        </td>
        <td class="cell-action">
            <a href="javascript:void(0);" class="action-icon" @click="onEdit(condition)" data-bs-toggle="modal" data-bs-target="#openConditionModal">
                <i class="mdi mdi-pencil"></i>
            </a>
            <a href="javascript: void(0);" class="action-icon text-danger" @click="onDelete(condition.id)">
                <i class="mdi mdi-delete"></i>
            </a>
        </td>
    </tr>
</template>

<script>
export default {
    name: 'ConditionRow',
    props: {
        conditionValue: {
            type: Object,
            required: true
        },
        onEdit: {
            type: Function,
            required: true
        },
        onDelete: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            condition: this.conditionValue,
        };
    },
    watch: {
        conditionValue: {
            handler(newCondition) {
                this.condition = newCondition;
            },
            deep: true
        }
    },   
}
</script>
